module.exports = __webpack_public_path__ + "img/housing_2.3b951f49.jpg";